<div class="margin-top">
    <mat-checkbox [(ngModel)]="moi.settings.content.courseListSettings.showOnlyJourney" color="primary">Show only journey</mat-checkbox>
</div>